import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const GradientBox = styled(Box)(({ theme }) => ({
  backgroundImage: `linear-gradient(97.99deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 101.11%)`,
}));
